export enum LoggingSeverity {
    Error = "Error",
    Warning = "Warning",    
    Info = "Info",
    Debug = "Debug"
}